import moment from 'moment-timezone';

export const nowAsTimestamp = () => Date.now();
export const nowAsDate = () => new Date();
export const nowAsZulu = () => new Date().toISOString();
export const nowAsMoment = () => moment();
// noinspection JSCheckFunctionSignatures
export const nowAsIso = () => moment().toISOString(true); // use true to keep the time zone info

// noinspection JSCheckFunctionSignatures
export const bodAsIso = () => moment().startOf('day').toISOString(true); // use true to keep the time zone info
export const eodAsIso = () => moment().endOf('day').toISOString(true); // use true to keep the time zone info

export const nowTillLastYear = () => {
  const now = nowAsDate();
  const oneYearAgo = new Date(now.getFullYear() - 1, now.getMonth(), now.getDate());
  return {
    fromDate: oneYearAgo.toISOString(),
    toDate: now.toISOString(),
  };
};
